import {SEARCH_REQUEST_PAGE_LIMIT} from './search-list.model';
import {FormState} from './form-state.model';
import {getHttpParams} from '../helpers/request.helper';
import {SearchOrder} from '../enums/search-order.enum';

export class SearchQueryParams {
    orderByField?: string;
    orderDirection?: SearchOrder;
    filters?: FormState;

    constructor(props = {}) {
        Object.assign(this, props);
    }

    getHttpParams() {
        const {orderByField, orderDirection, filters = {}} = this;
        const nonEmptyFilters = Object.keys(filters)
            .filter(key => !!filters[key] || filters[key] === 0 || filters[key] === false)
            .reduce((result, key) => {
                result[key] = filters[key];
                return result;
            }, {});
        return getHttpParams({
            limit: SEARCH_REQUEST_PAGE_LIMIT,
            orderByField,
            orderDirection,
            ...nonEmptyFilters
        });
    }

    // pageSize?: number;
}
